
function isMobile() {
  return window.innerWidth/window.innerHeight <= (34/40);
}
export default isMobile;
